export enum ConditionEvaluatorVersion {
  V1 = 'v1',
}

export const VALIDATION_RULES_SYNTAX_DOCS_URL =
  'https://help.benchling.com/hc/en-us/articles/47935854263181-Validation-rules-syntax';
